<template>
	<BaseCmsPage v-slot="{page}">
		<Body class="about-us" />
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 class="about-title" v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>

		<div class="about-image about-first-image" v-if="page?.main_image"><span><BaseUiImage :data="page?.main_image_thumbs?.['width1920-height720']" alt="" default="/images/no-image-200.jpg" /></span></div>

		<div class="first-row wider-wrapper">
			<div class="cms-content" v-if="page?.content" v-html="page.content"  v-interpolation />
		</div>

		<div class="about-image about-second-image" v-if="page?.main_image2"><span><BaseUiImage :data="page?.main_image2_thumbs?.['width1920-height720']" alt="" default="/images/no-image-200.jpg" /></span></div>

		<div class="second-row wider-wrapper">
			<div class="cms-content" v-if="page?.element_extra" v-html="page.element_extra" v-interpolation />

			<CmsShare />
		</div>

		<CmsBenefits />
	</BaseCmsPage>
</template>

<style lang="less" scoped>
	.second-row .cms-content{padding-bottom: 20px;}
	.about-title{
		font-size: 54px;
		@media (max-width: @l){font-size: 48px;}
		@media (max-width: @t){font-size: 40px;}
		@media (max-width: @m){font-size: 26px; line-height: 1.2;}
	}
	.about-image{
		:deep(img){max-width: 100%; height: auto; width: auto; display: block; margin: auto;}
	}
	.second-row{
		padding-bottom: 100px;
		@media (max-width: @t){
			padding-bottom: 70px;
			.cms-content{padding: 35px 0 20px;}
		}
		@media (max-width: @tp){padding-bottom: 60px;}
		@media (max-width: @m){padding-bottom: 35px;}
	}

	@media (max-width: @l){
		.first-col, .second-col{width: 560px;}
	}
</style>

<style lang="less">
	.about-us{
		.cms-content{
			padding: 70px 0; display: flex; justify-content: space-between; font-weight: 300;
			&>div{width: calc(~"50% - 60px");}
		}
		@media (max-width: @t){
			.cms-content{padding: 35px 0;
				&>div{width: calc(~"50% - 25px");}
			}
		}
		@media (max-width: @tp){
			.cms-content{padding-left: 0;
				&>div{width: calc(~"50% - 15px");}
			}
		}
		@media (max-width: @m){
			.cms-content{
				flex-direction: column; padding: 20px 0;
				&>div{width: 100%;}
			}
		}
	}
</style>